import { useAuthStore } from '@/modules/auth/stores/auth.store'

export default [
  {
    path: '/digital-leader/clients',
    name: 'digital-leader-clients',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'digital-leader',
      breadcrumb: {
        label: 'digital-leader.breadcrumbs.clients',
        route: 'digital-leader-clients',
      },
    },
    beforeEnter: (to, from, next) => {
      const authStore = useAuthStore()
      if (authStore.isDigitalLeader) {
        next()
      }
      else {
        next({ name: 'Unauthorized' })
      }
    },
    component: () => import('@/modules/digital-leader/containers/digital-leader-clients.container.vue'),
  },
]
